import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getCarinfoByVin } from '../../utils/api';

// Custom SVG Icons
const GaugeIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6v2M6 12h2M18 12h-2M12 12l3-3" strokeLinecap="round" />
    </svg>
);

const VinIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M7 8h10M7 12h6M7 16h8" strokeLinecap="round" />
    </svg>
);

const TagIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M7 7h.01M7 3h5l9 9-7 7-9-9V3z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const LocationIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 21s-8-7.5-8-12a8 8 0 1116 0c0 4.5-8 12-8 12z" />
        <circle cx="12" cy="9" r="3" />
    </svg>
);

const CheckIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const MarketCarInfo = ({ carDetail, setCompare, compare, setLoading, pageType }) => {
    const { vin, year, make, model, state, city, dealerName, mileage, price, photoUrls, trim } = carDetail;
    const isSelected = compare.map((item) => item?.carDetail?.vin).includes(vin);

    const handleComparison = (car, key) => {
        if (key === "add") {
            setLoading(true);
            getCarinfoByVin(vin)
                .then((res) => {
                    if (res?.data) {
                        let data = [...compare, { carDetail: car, overView: res?.data }]
                        setCompare(data);
                        localStorage.setItem("compareCars", JSON.stringify(data));
                    }
                })
                .catch((e) => console.error(e)).finally(() => {
                    setLoading(false)
                })
        }
        if (key === "remove") {
            let filteredData = compare.filter((item) => item?.carDetail.vin !== car.vin)
            setCompare(filteredData);
            localStorage.setItem("compareCars", JSON.stringify(filteredData));
        }
    }

    const formatPrice = (priceStr) => {
        if (!priceStr) return 'Contact for Price';
        return priceStr;
    };

    return (
        <div className="vehicle-card group">
            {/* Image Container */}
            <div className="vehicle-card-image">
                {photoUrls && photoUrls[0] ? (
                    <img src={photoUrls[0]} alt={`${year} ${make} ${model}`} />
                ) : (
                    <div className="vehicle-card-no-image">
                        <svg className="w-16 h-16 text-slate-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                            <rect x="2" y="6" width="20" height="12" rx="2" />
                            <circle cx="7" cy="18" r="2" />
                            <circle cx="17" cy="18" r="2" />
                            <path d="M5 6l2-3h10l2 3" />
                        </svg>
                        <span>No Image</span>
                    </div>
                )}

                {/* Gradient Overlay */}
                <div className="vehicle-card-overlay" />

                {/* Select Button */}
                <div className="vehicle-card-select">
                    {isSelected ? (
                        <button
                            className="vehicle-btn-selected"
                            onClick={() => handleComparison(carDetail, "remove")}
                        >
                            <CheckIcon />
                            <span>Selected</span>
                        </button>
                    ) : (
                        compare.length < 4 && (
                            <button
                                className="vehicle-btn-select"
                                onClick={() => handleComparison(carDetail, "add")}
                            >
                                <span>+ Compare</span>
                            </button>
                        )
                    )}
                </div>

                {/* Year Badge */}
                <div className="vehicle-card-year">{year}</div>
            </div>

            {/* Content */}
            <div className="vehicle-card-content">
                {/* Header */}
                <div className="vehicle-card-header">
                    <h3 className="vehicle-card-title">{make} {model}</h3>
                    <div className="vehicle-card-price">{formatPrice(price)}</div>
                </div>

                {/* Specs Grid */}
                <div className="vehicle-card-specs">
                    <div className="vehicle-spec">
                        <VinIcon />
                        <span className="vehicle-spec-value">{vin?.toUpperCase()?.slice(0, 11)}...</span>
                    </div>
                    <div className="vehicle-spec">
                        <GaugeIcon />
                        <span className="vehicle-spec-value">{mileage || 'N/A'}</span>
                    </div>
                    {trim && (
                        <div className="vehicle-spec">
                            <TagIcon />
                            <span className="vehicle-trim-badge">{trim}</span>
                        </div>
                    )}
                    <div className="vehicle-spec">
                        <LocationIcon />
                        <span className="vehicle-spec-value vehicle-spec-location">{city}, {state}</span>
                    </div>
                </div>

                {/* Dealer */}
                <div className="vehicle-card-dealer">
                    <span>{dealerName}</span>
                </div>

                {/* Action Button */}
                <button
                    className="vehicle-card-btn"
                    onClick={() => {
                        let url = `/product_page/${vin}?isSalvage=${pageType === "SalvageCars"}`
                        localStorage.setItem("photoUrls", JSON.stringify(photoUrls));
                        localStorage.setItem("selectedProduct", JSON.stringify(carDetail));
                        window.open(url, "_blank");
                    }}
                >
                    <span>View Details</span>
                    <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M5 12h14M12 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default MarketCarInfo
